import { Magnitude } from '../models/magnitude';
import axiosInstance, { getDefaultRequestConfig } from './base/axios.client';

export async function getMagnitudes() {
  return await axiosInstance.get<Magnitude[]>(
    '/magnitudes',
    getDefaultRequestConfig('es')
  );
}
